export const LANGUAGES_ROUTE_NAMES = {
    LIST: "LanguagesList",
    CREATE: "LanguagesAdd",
    EDIT: "LanguagesEdit",
};
